// extracted by mini-css-extract-plugin
export default {"root":"c_TUSXPm","metricsContainer":"aCnH7G8Q","metricItem":"YUpuUk25","metricLabel":"tHacn9ZN","metricValue":"uXyIQzxB"};